"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spacingStyle = exports.insetPropType = exports.insetOptions = void 0;

var _styledComponents = require("styled-components");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _validation = require("../utils/validation");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    padding: ", ";\n    ", "\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      padding: ", ";\n      ", "\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      padding: 0;\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n      padding: ", ";\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}
/** basic inset options available */


var insetOptions = ['0', 'xSmall', 'small', 'normal', 'large', 'xLarge'];
/** sides that a can take an inset - in order */

exports.insetOptions = insetOptions;
var sides = ['top', 'right', 'bottom', 'left'];
/** Prop Type definition for components that take inset props */

var shape = Object.assign.apply(Object, _toConsumableArray(sides.map(function (key) {
  return _defineProperty({}, key, _propTypes.default.oneOf(insetOptions));
})));

var insetSides = _propTypes.default.shape(shape);

var insetPropType = _propTypes.default.oneOfType([_propTypes.default.oneOf(insetOptions), insetSides]);

exports.insetPropType = insetPropType;

var spacingStyle = function spacingStyle(theme) {
  var padding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var inset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  /** don't provide a padding rule if neither inset or padding has been provided */

  if (padding == null && inset == null) {
    return '';
  }
  /** use provided padding, overiding inset */


  if (padding) {
    return (0, _styledComponents.css)(_templateObject(), padding);
  }
  /** zero padding option */


  if (inset === '0') {
    return (0, _styledComponents.css)(_templateObject2());
  }
  /** if inset with sides have been supplied  */


  if (_typeof(inset) === 'object' && inset !== null) {
    var _mediaVariants = function _mediaVariants() {
      var mediaVariant = '';
      Object.keys(theme.breakpoints).forEach(function (point) {
        var shorthand = '';
        sides.forEach(function (side) {
          if (inset[side] === '0') {
            shorthand += "0 ";
          } else {
            shorthand += "".concat((0, _validation.nestedPropExists)(theme, 'spacing', inset[side], 'padding') && theme.spacing[inset[side]].padding[point], " ");
          }
        });
        mediaVariant += "\n          @media screen and (min-width: ".concat(theme.breakpoints[point], ") {\n            padding: ").concat(shorthand, "};\n          }\n        ");
      });
      return mediaVariant;
    };

    var xxsShorthand = '';
    sides.forEach(function (side) {
      if (inset[side] === '0') {
        xxsShorthand += "0 ";
      } else {
        xxsShorthand += "".concat((0, _validation.nestedPropExists)(theme, 'spacing', inset[side], 'padding') && theme.spacing[inset[side]].padding.xxs, " ");
      }
    });
    return (0, _styledComponents.css)(_templateObject3(), xxsShorthand, _mediaVariants);
  }
  /** single inset option supplied */


  var mediaVariants = function mediaVariants() {
    var mediaVariant = '';
    Object.keys(theme.breakpoints).forEach(function (point) {
      mediaVariant += "\n        @media screen and (min-width: ".concat(theme.breakpoints[point], ") {\n          padding: ").concat((0, _validation.nestedPropExists)(theme, 'spacing', inset, 'padding') && theme.spacing[inset].padding[point] || '', ";\n        }\n      ");
    });
    return mediaVariant;
  };

  return (0, _styledComponents.css)(_templateObject4(), (0, _validation.nestedPropExists)(theme, 'spacing', inset, 'padding') && theme.spacing[inset].padding.xxs || '', mediaVariants);
};

exports.spacingStyle = spacingStyle;